module.exports = __webpack_public_path__ + "static/media/expand-minus.bb7a8ab3.svg";